import { createAction } from '@reduxjs/toolkit';

import {
  HIDE_FOLDER_HIERARCHY,
  RESET_TRANSCRIPT_STATE,
  SHARE_VIDEO_MOVE_SUCCESS,
  SHOW_FOLDER_HIERARCHY,
  TOGGLE_IS_TRANSCRIPT_SEARCH_OPEN,
  UPDATE_CURRENT_SEARCH_INDEX,
  UPDATE_CURRENT_USER_IS_OWNER,
  UPDATE_SHARE_VIDEO,
  UPDATE_SHARE_VIDEO_DOWNLOAD_URL,
  UPDATE_SHARE_VIDEO_IFRAME_LOADED,
  UPDATE_SHARE_VIDEO_IN_TRIM_MODE,
  UPDATE_SHARE_VIDEO_NAME,
  UPDATE_SHARE_VIDEO_PASSWORD,
  UPDATE_SHARE_VIDEO_PLAYER_READY,
  UPDATE_SHARE_VIDEO_SHOW_REMOVE_MODAL,
  UPDATE_TRANSCRIPT_DETAILS,
  UPDATE_TRANSCRIPT_PANEL_MODE,
  UPDATE_TRANSCRIPT_SEARCH_INPUT_VALUE,
  UPDATE_TRANSCRIPT_SEARCH_PHRASE,
  UPDATE_TRANSCRIPT_SEARCH_PHRASE_INDEX_ARRAY,
  UPDATE_TRANSCRIPT_STATUS,
  UPDATE_TRANSCRIPT_VERSION,
  UPDATE_USER_HAS_OPENED_TRANSCRIPT,
  UPDATE_VIDEO_CTA,
  UPDATE_VIDEO_CTA_ENABLED,
  UPDATE_VIDEO_CTA_MODAL_SHOW,
  UPDATE_VIDEO_CTA_MODS,
  UPDATE_VIDEO_CTA_SHOW,
  UPDATE_VIDEO_CTA_TEXT,
  UPDATE_VIDEO_CTA_URL,
  UPDATE_VIDEO_DESCRIPTION,
  UPDATE_VIDEO_IFRAME_VISIBLITY,
  UPDATE_VIDEO_SHARE_ALIAS,
  UPDATE_VIDEO_SHARE_SFDC_MODAL_SHOW,
  UPDATE_WAVEFORM_GENERATION_DETAILS,
  UPDATE_WAVEFORM_GENERATION_STATUS,
  USER_HAS_UPDATED_BUTTON_TEXT,
} from 'constants/actions';

export const updateCurrentUserIsOwner = currentUserIsOwner => {
  return { type: UPDATE_CURRENT_USER_IS_OWNER, currentUserIsOwner };
};

export const videoMoveSuccess = folders => {
  return {
    type: SHARE_VIDEO_MOVE_SUCCESS,
    folders,
  };
};

export const showFolderHierarchy = () => ({ type: SHOW_FOLDER_HIERARCHY });

export const hideFolderHierarchy = () => ({ type: HIDE_FOLDER_HIERARCHY });

export const updateShareVideo = video => {
  return {
    type: UPDATE_SHARE_VIDEO,
    video,
  };
};

export const updateShareVideoName = name => {
  return {
    type: UPDATE_SHARE_VIDEO_NAME,
    name,
  };
};

export const updateVideoIframeVisibility = (isVisible = true) => {
  return {
    type: UPDATE_VIDEO_IFRAME_VISIBLITY,
    isVisible,
  };
};

export const updateShareVideoDownloadUrl = downloadUrl => {
  return { type: UPDATE_SHARE_VIDEO_DOWNLOAD_URL, downloadUrl };
};

export const updateShareVideoIframeLoaded = loaded => {
  return { type: UPDATE_SHARE_VIDEO_IFRAME_LOADED, loaded };
};

export const updateShareVideoInTrimMode = inTrimMode => {
  return { type: UPDATE_SHARE_VIDEO_IN_TRIM_MODE, inTrimMode };
};

export const updateShareVideoPassword = password => {
  return {
    type: UPDATE_SHARE_VIDEO_PASSWORD,
    password,
  };
};

export const updateShareVideoPlayerReady = playerReady => {
  return {
    type: UPDATE_SHARE_VIDEO_PLAYER_READY,
    playerReady,
  };
};

export const updateShareVideoShowRemoveModal = show => {
  return {
    type: UPDATE_SHARE_VIDEO_SHOW_REMOVE_MODAL,
    show,
  };
};

export const userHasUpdatedButtonText = button_text_updated => {
  return {
    type: USER_HAS_UPDATED_BUTTON_TEXT,
    button_text_updated,
  };
};

export const updateVideoCta = cta => {
  return {
    type: UPDATE_VIDEO_CTA,
    cta,
  };
};

export const updateVideoCtaEnabled = ctaEnabled => {
  return {
    type: UPDATE_VIDEO_CTA_ENABLED,
    ctaEnabled,
  };
};

export const updateVideoCtaShow = ctaShow => {
  return {
    type: UPDATE_VIDEO_CTA_SHOW,
    ctaShow,
  };
};

export const updateVideoCtaText = ctaText => {
  return {
    type: UPDATE_VIDEO_CTA_TEXT,
    ctaText,
  };
};

export const updateVideoCtaUrl = ctaUrl => {
  return {
    type: UPDATE_VIDEO_CTA_URL,
    ctaUrl,
  };
};

export const updateVideoCtaModalShow = showModal => {
  return {
    type: UPDATE_VIDEO_CTA_MODAL_SHOW,
    showModal,
  };
};

export const updateVideoCtaMods = mods => {
  return {
    type: UPDATE_VIDEO_CTA_MODS,
    mods,
  };
};

export const updateSalesforceModal = sfdcModalShow => {
  return {
    type: UPDATE_VIDEO_SHARE_SFDC_MODAL_SHOW,
    sfdcModalShow,
  };
};

export const updateShareVideoAliases = shareVideoAliases => {
  return {
    type: UPDATE_VIDEO_SHARE_ALIAS,
    shareVideoAliases,
  };
};

export const updateTranscriptDetails = transcriptDetails => {
  return {
    type: UPDATE_TRANSCRIPT_DETAILS,
    transcriptDetails,
  };
};

export const updateTranscriptVersion = version => {
  return {
    type: UPDATE_TRANSCRIPT_VERSION,
    version,
  };
};

export const updateUserHasOpenedTranscript = () => {
  return {
    type: UPDATE_USER_HAS_OPENED_TRANSCRIPT,
  };
};

export const resetTranscriptState = () => {
  return {
    type: RESET_TRANSCRIPT_STATE,
  };
};

export const updateTranscriptStatus = status => {
  return {
    type: UPDATE_TRANSCRIPT_STATUS,
    status,
  };
};

export const toggleIsTranscriptSearchOpen = isTranscriptSearchOpen => {
  return {
    type: TOGGLE_IS_TRANSCRIPT_SEARCH_OPEN,
    isTranscriptSearchOpen,
  };
};

export const updateTranscriptSearchPhrase = transcriptSearchPhrase => {
  return {
    type: UPDATE_TRANSCRIPT_SEARCH_PHRASE,
    transcriptSearchPhrase,
  };
};

export const updateTranscriptSearchPhraseIndexArray =
  transcriptSearchPhraseIndexArray => {
    return {
      type: UPDATE_TRANSCRIPT_SEARCH_PHRASE_INDEX_ARRAY,
      transcriptSearchPhraseIndexArray,
    };
  };

export const updateTranscriptPanelMode = transcriptPanelMode => {
  return {
    type: UPDATE_TRANSCRIPT_PANEL_MODE,
    transcriptPanelMode,
  };
};

export const updateWaveformGenerationDetails = (status, url) => {
  return {
    type: UPDATE_WAVEFORM_GENERATION_DETAILS,
    status,
    url,
  };
};

export const updateWaveformGenerationStatus = status => {
  return {
    type: UPDATE_WAVEFORM_GENERATION_STATUS,
    status,
  };
};

export const updateCurrentSearchIndex = currentSearchIndex => {
  return {
    type: UPDATE_CURRENT_SEARCH_INDEX,
    currentSearchIndex,
  };
};

export const updateTranscriptSearchInputValue = transcriptSearchInputValue => {
  return {
    type: UPDATE_TRANSCRIPT_SEARCH_INPUT_VALUE,
    transcriptSearchInputValue,
  };
};

export const updateVideoDescriptionState = description => {
  return {
    type: UPDATE_VIDEO_DESCRIPTION,
    description,
  };
};

export const updateAnonymousUsername = createAction(
  'update-anonymous-username'
);

export const setAnonCreatorMode = createAction('set-anon-creator-mode');

export const updateShareVideoRecordingVersion = createAction(
  'update-share-video-recording-version',
  payload => ({ payload })
);
